import { LocalOperation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { unGroupFormElements, UnGroupFormElementsAction } from 'store/data/forms';
import { ActionPayload } from 'store/types';

export function useUnGroupFormElements(): LocalOperation<
	(payload: ActionPayload<UnGroupFormElementsAction>) => void
> {
	const dispatch = useDispatch();

	function handler(payload: ActionPayload<UnGroupFormElementsAction>) {
		dispatch(unGroupFormElements(payload));
	}

	return handler;
}
